import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NeproseService } from '../services/neprose.service';
import { MatDialog } from '@angular/material/dialog';
import { BankPaymentComponent } from '../components/bank-payment/bank-payment.component';
import { BankTransferComponent } from '../components/bank-transfer/bank-transfer.component';
import { SeoSocialShareData, SeoSocialShareService } from 'ngx-seo';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements OnInit {

  productId: any

  esewaPaymentParams= {
      amt: 100,
      psc: 0,
      pdc: 0,
      txAmt: 0,
      tAmt: 100,
      pid: '',
      scd: 'NP-ES-NEPALPROPERTY',
      // scd: 'epay_payment',
      su: '',
      fu: ''
  }

  adPlans = []

  url = environment.esewa + '/epay/main'

  property: any

  selectedPlan: any

  seoData: SeoSocialShareData = {
    title:  'Payment',
    description: 'Payment portal for Nepal Property Services.',
    image: environment.url+'/assets/logo.png'
  };

  constructor( private route: ActivatedRoute, private auth: AuthService, private notification: MatSnackBar, private _neproseService: NeproseService,
    private cdr: ChangeDetectorRef, private dialog: MatDialog, private router: Router, private seo: SeoSocialShareService ) { }

  ngOnInit(): void {
    this.seo.setData(this.seoData)
    this.productId = this.route.snapshot.params.id
    this.route.data.subscribe((data: { propertyAd: any, adPlans: any }) =>{
      this.property = data.propertyAd.propertyAd
      this.adPlans = data.adPlans
      if(this.property.status == 'pending' || this.property.status == 'expired'){
        this.setUpEsewa()
      }else{
        this.router.navigate(['404'])
      }
    })
    this.route.queryParams
      .subscribe(params => {
        if(params.message == 'esewa-payment-failed') {
            this.openNotification('Esewa payment failed! Please try again.')
        }
      });
  }

  setUpEsewa(){
    this.selectedPlan = this.adPlans.find(selectedPlan => selectedPlan.id == this.property.ad_plan_id)
    this.esewaPaymentParams.amt = this.selectedPlan.price
    this.esewaPaymentParams.tAmt = this.esewaPaymentParams.amt
    if(this.productId){
      this.esewaPaymentParams.fu = environment.url+'/property/'+this.productId+'/payment?message=esewa-payment-failed'
      this.esewaPaymentParams.su = environment.url+'/property/'+this.productId+'/esewa-payment-success'
      this.esewaPaymentParams.pid = this.property.aliasId
    }
    this.cdr.detectChanges()
  }

  selectPlan(id){
    let property = Object.assign({},this.property)
    property['ad_plan_id'] = id
    delete property['PropertyImage']
    delete property ['PropertyType']
    delete property['approvalDate']
    delete property['createdAt']
    delete property['updatedAt']
    delete property['availableFrom']
    delete property['user_id']
    delete property['status']
    delete property['id']
    delete property['totalView']
    delete property['aliasId']
    delete property['title_np']
    this._neproseService.updateProperty(this.property.id, property).subscribe(data => {
      if(data.status){
        this.openNotification('New Advertisement Plan has been selected.')
        this.property = data.propertyAd
        this.setUpEsewa()
      }
    }, error => {
      if(error.error){
        this.openNotification(error.error.message)
      }
    })
  }

  openNotification(msg){
    this.notification.open(msg, 'Cancel', {
      duration: 2000,
      horizontalPosition: 'right'
    })
  }

  bankPayment(){
    const dialogRef = this.dialog.open(BankPaymentComponent, {
      width: '70%',
      data: {
        property_id: this.property.aliasId,
        voucherPath: null,
        remarks: '',
        image: null
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        result['property_id'] = this.property.aliasId
        this._neproseService.addBankPayment(result).subscribe(data => {
          if(data.status){
            this.openNotification('Bank payment verification may take some time. Thank you!')
            this.router.navigate(['edit-property/'+this.property.id])
          }
        }, error => {
          if(error.error.message){
            this.openNotification(error.error.message)
          }
        })
      }
    })
  }

  bankTransfer(){
    const dialogRef = this.dialog.open(BankTransferComponent, {
      width: '70%',
      data: {
        paymentMethod: '',
        property_id: this.property.aliasId,
        transaction_id: '',
        amount: this.esewaPaymentParams.tAmt,
        voucherPath: null,
        image: null
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.auth.savePaymentDetails(result).subscribe(data => {
          if(data.status){
            this.openNotification('Payment verification may take some time. Thank you!')
            this.router.navigate(['edit-property/'+this.property.id])
          }
        }, error => {
          if(error.error.message){
            this.openNotification(error.error.message)
          }
        })
      }
    })
  }

  payInCash(){
    let result = {
      paymentMethod: 'Pay In Cash',
      property_id: this.property.aliasId,
      transaction_id: this.property.aliasId,
      amount: this.esewaPaymentParams.tAmt
    }
    this.auth.savePaymentDetails(result).subscribe(data => {
      if(data.status){
        this.openNotification('Payment verification may take some time. Thank you!')
        this.router.navigate(['edit-property/'+this.property.id])
      }
    }, error => {
      if(error.error.message){
        this.openNotification(error.error.message)
      }
    })
  }

}
